module.exports = __webpack_public_path__ + "img/ssl.f006d94b.svg";